// extracted by mini-css-extract-plugin
export default {"card":"FeedItemSkeleton-module-card","image":"FeedItemSkeleton-module-image","title":"FeedItemSkeleton-module-title","price":"FeedItemSkeleton-module-price"};